import { render, staticRenderFns } from "./ListaFuncionarios.vue?vue&type=template&id=306de6b6&"
import script from "./ListaFuncionarios.vue?vue&type=script&lang=js&"
export * from "./ListaFuncionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports